<template>
    <div :class="inputClass">
        <div class="form-input-text--label">
            <span v-if="label" class="form-input-text--label__text">{{ label }}:</span>
            <span v-if="showInfoTip">
                <common-info-tip :containerDimensions="containerDimensions">
                    <span>{{ infoTipMessage }}</span>
                </common-info-tip>
            </span>
        </div>
        <input
            :value="prefill"
            :placeholder="placeholder"
            :autofocus="hasAutofocus"
            :required="isRequired"
            :type="type"
            :name="name"
            :disabled="isDisabled"
            @keyup.enter="emitEvent({ name: 'enter-click' })"
            @blur="emitEvent({ name: 'blur' })"
            @focus="emitEvent({ name: 'focus' })"
            @input="change($event)"
        />
        <span v-if="errorMessage" class="form-input-text--error">{{ errorMessage }}</span>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            type: { type: String, default: 'text' },
            showInfoTip: { type: Boolean, default: false },
            infoTipMessage: { type: String, default: '' },
            containerDimensions: { type: Object, default: undefined },
        },

        computed: {
            inputClass() {
                return {
                    'form-input-text': true,
                    'form-input-text--is-invalid': !!this.errorMessage,
                    'form-input-text--is-disabled': this.isDisabled,
                }
            },
        },
    }
</script>
